module.exports = __webpack_public_path__ + "media/img/pages/companies/bosch-ee7f0f22742780540fcccb9a0eb53456.png";